import CatchErrors from 'components/common/catch-errors';
import * as toolbox from 'components/common/toolbox';
import AssetsTab from 'components/stock-parts/stock-part/assets-tab';
import React from 'react';
import { Route, Link } from "react-router-dom";

const StockPartTabs = (props) => {

	function tab_active(value) {
		return (props.match.params.tab === value) ? ' active' : ''; // returns 'active' if value tab is active
	}
	function tab_url(value) {
		return toolbox.modifyPath(props.location.pathname, 7, value, 7);
	}

	return (
		<>
			<Route path={props.match.path} render={(route_props) =>

				<div className="tabs-container" style={{ marginTop: '20px' }}>
					<ul className="nav nav-tabs" role="tablist">
						<li><Link className={'nav-link' + tab_active('assets')} to={tab_url('assets')} replace={true}> Assets &nbsp;</Link></li>
						<li><Link className={'nav-link' + tab_active('use_history')} to={tab_url('use_history')} replace={true}> Use History &nbsp;</Link></li>
						<li><Link className={'nav-link' + tab_active('Purchase History')} to={tab_url('Purchase History')} replace={true}> Purchase History &nbsp;</Link></li>
					</ul>

					<div className="tab-content">

						{(props.match.params.tab === 'assets') && <div role="tabpanel" className={'tab-pane' + tab_active('assets')}>
							<div className="panel-body">
								<Route path={props.match.path} render={(route_props) =>
									<CatchErrors>
										<AssetsTab {...route_props} />
									</CatchErrors>
								} />
							</div>
						</div>}

					</div>
				</div>

			} />
		</>
	);
};

export default StockPartTabs

